import { AxiosError } from "axios";
import { apiMain } from "@/common/services";
import { IOperation } from "@/common/services/RedGifsService";
import { IErrorData, IUserSettings } from "@/common/services/types";
import { showNotification } from "@/components/notifications/Notifications";
import { useUpdateUserData } from "@/common/hooks/useUpdateUserData";

export const useUserSettingsHandlers = () => {
  const { updateUserData: updateUserProfileData } = useUpdateUserData<IOperation[]>({
    updateRequest: (params) => apiMain.updateProfileInfo(params),
  });

  const { updateUserData: updateUserSettingsData } = useUpdateUserData<IUserSettings>({
    updateRequest: (params) => apiMain.updateUserSettings(params),
  });

  const handleApiError = (e: unknown) => {
    const err = e as AxiosError<IErrorData>;
    const message = err.response?.data?.error?.message ||
      "An error occurred, please try again later";

    showNotification({
      title: message,
      variant: "error",
    });
  };

  const handleSuccessNotification = () => {
    showNotification({
      title: "Successfully updated!",
      variant: "success",
    });
  };

  const updateUserProfile = async (params: IOperation[]) => {
    try {
      await updateUserProfileData(params);
      handleSuccessNotification();
    } catch (e) {
      handleApiError(e);
    }
  };

  const updateUserSettings = async (params: IUserSettings) => {
    try {
      await updateUserSettingsData(params);
      handleSuccessNotification();
    } catch (e) {
      handleApiError(e);
    }
  };

  return {
    updateUserSettings,
    updateUserProfile
  };
};
